// Copyright (c) 2021 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as TimelineActions from "../actions"
import { EmptyTrashRequest, EmptyTrashResponse, } from "../../../generated/wisetime/user/timeline/v4/timeline_pb"

import { grpc } from "../../../app/rpc/executor"
import { timelineClient } from "../../../app/rpc/client"
import * as TimelineSlice from "../slices/timeline"
import { t } from "@lingui/macro"
import { showSnackBar } from "../../snackbar/actions"

type EmptyTrashRpc = (request: EmptyTrashRequest) => Observable<EmptyTrashResponse>

export const emptyTrash = (emptyTrashRpc: EmptyTrashRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(TimelineActions.emptyTrash.match),
      mergeMap(action => of(action.payload.request).pipe(
        mergeMap(emptyTrashRpc),
        map(_ => {
          action.payload.onComplete()
          return TimelineSlice.removeAllTrashedTimeRows()
        }),
        catchError(_ => of(showSnackBar({
          message: t({
            id: "msg_empty_trash_failed",
            message: "Failed to empty trash. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com."
          }),
          messageType: "ERROR",
        })))),
      )
    )

const emptyTrashRpc = (request: EmptyTrashRequest): Observable<EmptyTrashResponse> =>
  grpc(() => timelineClient.emptyTrash(request, null))

export default emptyTrash(emptyTrashRpc)
